import request from "../utils/fetch";

// 设备列表
export function shebeiList(data) {
  return request({
    url: "/equipment/enterprise/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 设备详情
export function shebeiDetail(data) {
  return request({
    url: "/equipment/pc/id/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 家用机设备详情
export function homeShebeiInfo(data) {
  return request({
    url: "/equipment/pc/new/id/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 批量启用设备
export function startShebeiList(data) {
  return request({
    url: "/equipment/pc/list/startStatusEquipment",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 批量禁用设备
export function endShebeiList(data) {
  return request({
    url: "/equipment/pc/list/forbiddenStatusEquipment",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 上传头像
export function uploadHeader(data) {
  return request({
    url: "/public/file/upload?folder=PC",
    method: "post",
    requestBody: "upload",
    loading: true,
    data: data,
  });
}

// 型号下拉
export function typeList(data) {
  return request({
    url: "/equipment/ver/pullList",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 企业设备统计
export function numStat(data) {
  return request({
    url: "/equipment/enterprise/countEquipment",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 滤芯列表
export function filterList(data) {
  return request({
    url: "/equipment/filter/equipment/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 滤芯删除
export function filterDel(data) {
  return request({
    url: "/equipment/filter/del",
    method: "DELETE",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 滤芯重置
export function filterYuan(data) {
  return request({
    url: "/equipment/filter/return",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 密码二次确认
export function pwdNotarize(data) {
  return request({
    url: "/equipment/waterList/checkPassword",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 运营数据
export function operatorData(data) {
  return request({
    url: "/equipment/company/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 运营数据新
export function operatorDataNew(data) {
  return request({
    url: "/order/statistics/equipment/consume/get/sum",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 编辑购水模式
export function modelEdit(data) {
  return request({
    url: "/equipment/pc/upadte/buy/type",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 开机
export function on(data) {
  return request({
    url: "/api/test/on",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}
// 关机
export function off(data) {
  return request({
    url: "/api/test/off",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 滤芯预警列表
export function filterEarlyList(data) {
  return request({
    url: "/equipment/filter/warning/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 滤芯预警列表跟进
export function filterEarlyCheck(data) {
  return request({
    url: "/equipment/filter/warning/follow",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 滤芯预警统计
export function filterStat(data) {
  return request({
    url: "/equipment/filter/warning/statistics",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 设备单价详情
export function priceDetail(data) {
  return request({
    url: "/equipment/pc/get/price",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function priceDetailNew(data) {
  return request({
    url: "/equipment/waterList/id/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function savePriceEdit(data) {
  return request({
    url: "/equipment/pc/upadte/price",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 滤芯列表
export function filter(data) {
  return request({
    url: "/equipment/filter/equipment/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 家用设备解绑
export function shebeiJieUser(data) {
  return request({
    url: "/equipment/customer/equipment/unbind",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 滤芯新增
export function filteradd(data) {
  return request({
    url: "/equipment/filter/shebei/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 错误码列表
export function errorList(data) {
  return request({
    url: "/public/error/code/page",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 新增错误码
export function errorAdd(data) {
  return request({
    url: "/public/error/code/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 修改错误码
export function errorEdit(data) {
  return request({
    url: "/public/error/code/edit",
    method: "PUT",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 删除错误码
export function errorDel(data) {
  return request({
    url: "/public/error/code/del",
    method: "DELETE",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 故障列表
export function troubleList(data) {
  return request({
    url: "/api/error/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 查询单价是否下发成功
export function priceIsSuccess(data) {
  return request({
    url: "/api/equipment/status/price/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
